<script setup>
/**
 * @fileoverview Alert component based on shadcn-vue
 * @description Alert box with variants for different message types
 * @example
 * <Alert variant="default">
 *   <AlertTitle>Heads up!</AlertTitle>
 *   <AlertDescription>You can add components to your app.</AlertDescription>
 * </Alert>
 */
import { computed } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'destructive'].includes(value)
  },
  class: {
    type: String,
    default: ''
  }
})

const alertVariants = computed(() => {
  const baseStyles =
    'relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground'

  const variants = {
    default: 'bg-background text-foreground',
    destructive:
      'border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive'
  }

  return cn(baseStyles, variants[props.variant], props.class)
})
</script>

<template>
  <div role="alert" :class="alertVariants">
    <slot />
  </div>
</template>
